import { render } from "./Create.vue?vue&type=template&id=b38a38a0&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=b38a38a0&scoped=true&lang=css"
import "./Create.vue?vue&type=style&index=1&id=b38a38a0&lang=css"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/CERAMICAS/mi-stock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b38a38a0"]])

export default __exports__